"use client";

import { PropsWithChildren, ReactNode } from "react";
import {
	AppHeader,
	Container,
	CountryProvider,
} from "@leabankab/component-library";
import { Footer } from "@/components/layout";
import type { CountryCode } from "@/config/country-config";
import { FormProvider } from "@/contexts/form";

/** `country` comes from `resolveCountry()` in the root layout. */
type Props = PropsWithChildren<{ country: CountryCode; alertSlot?: ReactNode }>;

export const PageLayout = ({ country, children, alertSlot }: Props) => (
	<CountryProvider country={country}>
		<div className="flex flex-col min-h-screen w-full">
			<AppHeader />
			{alertSlot}
			<Container render={<main />} className="flex-1">
				<FormProvider>{children}</FormProvider>
			</Container>
			<Footer />
		</div>
	</CountryProvider>
);
